// extracted by mini-css-extract-plugin
module.exports = {"pane-waitlist":"pane-waitlist__2i8Cp","waitlist-title":"waitlist-title__1br6z","waitlist-description":"waitlist-description__1fgno","bold":"bold__3NDBM","red":"red__43NvG"};